module.exports = __webpack_public_path__ + "static/media/course-slot-dropdown.56fc0060.svg";